import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Question } from './question';
import { BadInputError, Result, UniqueEntityID } from '@digibricks/core';
import { CorrectAnswer, SingleChoiceCorrectAnswer } from '../correct-answers';
import { Answer } from '../answer';
import { QuestionType } from '../question-type';
import { MultipleChoiceQuestion } from './multiple-choice-question';
import { FillInBlankQuestion } from './fill-in-blank-question';
import { EssayQuestion } from './essay-question';
import { MatchingQuestion } from './matching-question';
import { SpeakingQuestion } from './speaking-question';
export var SingleChoiceQuestion = /*#__PURE__*/function (_Question) {
  _inherits(SingleChoiceQuestion, _Question);

  var _super = _createSuper(SingleChoiceQuestion);

  function SingleChoiceQuestion() {
    _classCallCheck(this, SingleChoiceQuestion);

    return _super.apply(this, arguments);
  }

  _createClass(SingleChoiceQuestion, [{
    key: "answers",
    get: function get() {
      return this.props.answers;
    }
  }, {
    key: "correctAnswers",
    get: function get() {
      return this.props.correctAnswers;
    }
  }, {
    key: "cloneExtendedProps",
    value: function cloneExtendedProps(question, newQuestionProps) {
      var singleChoiceQuestion = question;

      switch (newQuestionProps.type) {
        case QuestionType.MultipleChoice:
          {
            var multipleChoiceQuestionProps = newQuestionProps;
            var answers = singleChoiceQuestion.answers,
                correctAnswers = singleChoiceQuestion.correctAnswers;
            multipleChoiceQuestionProps.answers = answers.map(function (a) {
              return a.clone();
            });

            if (correctAnswers.length > 0) {
              var newCorrectAnswers = [correctAnswers[0]];
              multipleChoiceQuestionProps.correctAnswers = newCorrectAnswers.map(function (c) {
                return c.clone();
              });
            }

            return MultipleChoiceQuestion.create(multipleChoiceQuestionProps);
          }

        case QuestionType.FillInBlank:
          {
            return FillInBlankQuestion.createDefault(newQuestionProps);
          }

        case QuestionType.Essay:
          return EssayQuestion.create(newQuestionProps);

        case QuestionType.Speaking:
          return SpeakingQuestion.createDefault(newQuestionProps);

        case QuestionType.Matching:
          {
            return MatchingQuestion.createDefault(newQuestionProps);
          }

        case QuestionType.SingleChoice:
          {
            var _singleChoiceQuestion = question;
            var singleChoiceQuestionProps = newQuestionProps;
            singleChoiceQuestionProps.answers = _singleChoiceQuestion.answers.map(function (a) {
              return a.clone();
            });
            singleChoiceQuestionProps.correctAnswers = _singleChoiceQuestion.correctAnswers.map(function (c) {
              return c.clone();
            });
            return SingleChoiceQuestion.create(singleChoiceQuestionProps);
          }
      }
    }
  }, {
    key: "addNewAnswer",
    value: function addNewAnswer(answer) {
      this.props.answers = [].concat(_toConsumableArray(this.props.answers), [answer]);
      return Result.ok();
    }
  }, {
    key: "deleteAnswer",
    value: function deleteAnswer(answerId) {
      var onlyOneAnswer = this.answers.length === 1;

      if (onlyOneAnswer) {
        return new BadInputError('The question should have at least one answer');
      }

      var answersUpdate = this.props.answers.filter(function (answer) {
        return answer.id.toString() !== answerId;
      });
      var deletedCorrectAnswerResult = this.deleteCorrectAnswer(answerId);

      if (deletedCorrectAnswerResult.isFailure) {
        return deletedCorrectAnswerResult;
      }

      this.props.answers = answersUpdate;
      var newCorrectAnswers = CorrectAnswer.create({
        answerId: this.props.answers[0].id.toString()
      }).getValue();
      this.props.correctAnswers = [newCorrectAnswers];
      return Result.ok();
    }
  }, {
    key: "deleteCorrectAnswer",
    value: function deleteCorrectAnswer(answerId) {
      var correctAnswersUpdate = this.props.correctAnswers.filter(function (correctAnswer) {
        return correctAnswer.answerId.toString() !== answerId;
      });
      this.props.correctAnswers = correctAnswersUpdate;
      return Result.ok();
    } // TODO: Will remove this after refactor question.

  }, {
    key: "updateAnswerDescription",
    value: function updateAnswerDescription(answerId, answerDescription) {
      this.props.answers = _toConsumableArray(this.props.answers).map(function (answer) {
        if (answer.id.toString() === answerId) {
          answer.updateDescription(answerDescription);
        }

        return answer;
      });
    }
  }, {
    key: "updateAnswer",
    value: function updateAnswer(answer) {
      this.props.answers.splice(this.props.answers.indexOf(answer), 1, answer);
      return Result.ok();
    }
  }, {
    key: "updateCorrectAnswer",
    value: function updateCorrectAnswer(answerIds) {
      var answerId = answerIds[0];
      var newCorrectAnswer = SingleChoiceCorrectAnswer.create({
        answerId: answerId
      }).getValue();
      this.props.correctAnswers = [newCorrectAnswer];
      return Result.ok();
    }
  }, {
    key: "updateAnswers",
    value: function updateAnswers(answers) {
      this.props.answers = answers;
      return Result.ok();
    }
  }, {
    key: "updateCorrectAnswers",
    value: function updateCorrectAnswers(correctAnswers) {
      if (correctAnswers.length === 0) {
        return new BadInputError('The correct answers cannot be empty');
      }

      var answerIds = correctAnswers.map(function (ca) {
        return ca.answerId;
      });

      var _answerIds = _slicedToArray(answerIds, 1),
          answerId = _answerIds[0];

      var isNotValidAnswers = !this.answers.map(function (a) {
        return a.id.toString();
      }).includes(answerId);

      if (isNotValidAnswers) {
        return new BadInputError('The Correct answers are not existed in answers');
      }

      this.props.correctAnswers = correctAnswers;
      return Result.ok();
    }
  }, {
    key: "toJsonObject",
    value: function toJsonObject() {
      return _objectSpread(_objectSpread({}, _get(_getPrototypeOf(SingleChoiceQuestion.prototype), "toJsonObject", this).call(this)), {}, {
        answers: this.props.answers.map(function (a) {
          return a.toJsonObject();
        }),
        correctAnswers: this.props.correctAnswers.map(function (c) {
          return c.toJsonObject();
        })
      });
    }
  }, {
    key: "createDefault",
    value: function createDefault(description) {
      return null;
    }
  }, {
    key: "toJsonV2",
    value: function toJsonV2() {
      return _objectSpread(_objectSpread({}, _get(_getPrototypeOf(SingleChoiceQuestion.prototype), "toBaseJson", this).call(this)), {}, {
        answers: this.answers.map(function (a) {
          return a.toJsonObject();
        }),
        correctAnswers: this.correctAnswers.map(function (a) {
          return a.toJsonObject();
        })
      });
    }
  }], [{
    key: "create",
    value: function create(props) {
      var basePropsOrError = _get(_getPrototypeOf(SingleChoiceQuestion), "createBaseProps", this).call(this, props);

      if (basePropsOrError.isFailure) {
        return Result.fail(basePropsOrError.error);
      }

      var resultOrError = this.validate(props);

      if (resultOrError.isFailure) {
        return Result.fail(resultOrError.error);
      }

      var defaultProps = _objectSpread(_objectSpread(_objectSpread({}, basePropsOrError.getValue()), props), {}, {
        type: QuestionType.SingleChoice
      });

      return Result.ok(new SingleChoiceQuestion(defaultProps, new UniqueEntityID(props.id)));
    }
  }, {
    key: "createDefault",
    value: function createDefault(props) {
      var basePropsOrError = _get(_getPrototypeOf(SingleChoiceQuestion), "createBaseProps", this).call(this, props);

      if (basePropsOrError.isFailure) {
        return Result.fail(basePropsOrError.error);
      }

      var firstAnswer = Answer.create({
        description: ''
      }).getValue();
      var correctAnswers = [CorrectAnswer.create({
        answerId: firstAnswer.id.toString()
      }).getValue()];
      var question = SingleChoiceQuestion.create(_objectSpread(_objectSpread({}, basePropsOrError.getValue()), {}, {
        answers: [firstAnswer],
        correctAnswers: correctAnswers
      }));
      return question;
    }
  }, {
    key: "fromJson",
    value: function fromJson(data) {
      try {
        var answers = data.answers,
            correctAnswers = data.correctAnswers;

        var basePropsOrError = _get(_getPrototypeOf(SingleChoiceQuestion), "fromJsonBase", this).call(this, data);

        if (basePropsOrError.isFailure) {
          return Result.fail(basePropsOrError.error);
        }

        var answerResultCombine = answers.map(function (a) {
          return Answer.fromJson(a);
        });
        var answerPropsOrError = Result.combineArray(answerResultCombine);

        if (answerPropsOrError.isFailure) {
          return Result.fail(answerPropsOrError.error);
        }

        var correctAnswerProps = correctAnswers ? correctAnswers.map(function (c) {
          return SingleChoiceCorrectAnswer.create({
            id: c.id,
            answerId: c.answerId
          }).getValue();
        }) : [];
        return this.create(_objectSpread(_objectSpread({}, basePropsOrError.getValue()), {}, {
          answers: answerPropsOrError.getValue(),
          correctAnswers: correctAnswerProps,
          type: QuestionType.SingleChoice
        }));
      } catch (error) {
        return Result.fail(error);
      }
    }
  }]);

  return SingleChoiceQuestion;
}(Question);